export default __webpack_public_path__ + "locales/lv/Common.json?hash=3ebec6c1e1cd3e44bd5fb84158f708d7";